/**
 * GA4 埋点封装。
 *
 * gtag 脚本由 index.html 按 VITE_GA_ID 注入与否决定加载（本地 dev / 测试
 * 构建不配置该变量 → window.gtag 不存在 → 以下函数全部 no-op，调用方无需判断）。
 *
 * 事件口径见 90-day-plan.md §3（W0 GA4 任务）：
 * sign_up / generation_start / image_generation_start / generation_download /
 * plaza_publish / checkout_click + SPA 路由 page_view（App.tsx 挂载）。
 */

type Gtag = (...args: unknown[]) => void;

function gtag(): Gtag | undefined {
  return typeof window !== "undefined" && "gtag" in window
    ? (window as unknown as { gtag: Gtag }).gtag
    : undefined;
}

/** SPA 手动 page_view（index.html 的 gtag config 已设 send_page_view:false，不会双计） */
export function trackPageView(path: string) {
  gtag()?.("event", "page_view", { page_path: path });
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  gtag()?.("event", name, params);
}
